import React from "react";
import "./Kpi.scss"

function Kpi({ caption = 'N/A',  pct , indicatorPosition = 50}) {
    const randomProgress = getRandom(0,100)
    return <>
        <div className={"kpi-container"} >
            <div className={"kpi-caption"}>{caption}</div>
            <div className={"kpi-progress-bar"}>
                <div className={`kpi-progress position-${pct}`} >{pct}</div>
                <div className={`kpi-indicator indicator-position-${getRandom(0,100)}`} />
            </div>
        </div>
    </>
}
function getRandom(min=0, max =0) {
    return Math.floor(Math.random() * (+max - +min)) + +min;
}
export default Kpi;
